import styled from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "SpecCardSkeletonstyles__Wrapper",
  componentId: "sc-1vcoyd2-0"
})(["padding:15px 15px;border:solid ", ";border-width:0 0 1px;@media screen and (min-width:", "){border-width:1px;border-radius:3px;}"], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].sm;
});
export { Wrapper };